import { render } from "./ProgressPieChart.vue?vue&type=template&id=0d9290c1&scoped=true"
import script from "./ProgressPieChart.vue?vue&type=script&lang=js"
export * from "./ProgressPieChart.vue?vue&type=script&lang=js"

import "./ProgressPieChart.vue?vue&type=style&index=0&id=0d9290c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9290c1"]])

export default __exports__